import FirstPage from "./pages/FirstPage";
import SecoundPage from "./pages/SecoundPage";
import "./css/pages.css";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
function App() {
  // var page = document.getElementById("pages");
  const particlesInit = async (tsParticles) => {
    console.log(tsParticles);

    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(tsParticles);
  };

  const particlesLoaded = (container) => {
    console.log(container);
  };
  return (
    <section className="App" id="pages" onScroll={onscroll}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "#282c34",
            },
          },
          fpsLimit: 60,
          autoPlay: true,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "attract",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 5,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: ["#FF69B4", "#ffffff", "#29D3FE", "#FFB380"],
            },
            collisions: {
              enable: true,
            },
            move: {
              direction: "random",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: true,
              speed: 5,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 500,
              },
              value: 100,
            },
            opacity: {
              value: 0.7,
            },
            shape: {
              type: ["circle", "square", "triangle"],
            },
            size: {
              value: { min: 10, max: 25 },
            },
            motion: {
              factor: true,
            },
          },
          detectRetina: true,
        }}
      />
      <FirstPage />
      <SecoundPage />
    </section>
  );
}

export default App;
